import { baseQuery } from '../baseQuery';

export const postVoipResume = async () => {
  const { data } = await baseQuery('voip-resume', {
    type: 'POST',
  });

  return data;
};
